import styled from '@emotion/styled'

const StyledDivider = styled('div', {shouldForwardProp: (prop) => prop !== 'showNotification'})(
  ({theme, showNotification}) => ({
    marginTop: showNotification ? '' : theme.spacing(4),
    marginBottom: theme.spacing(4),
    border: `1px solid ${theme.palette.grey[200]}`
  })
)

export {StyledDivider}
